import React, { useState } from "react";
import FullPageLoaderModal from "../../Modals/FullPageLoaderModal";

const UseFullPageLoaderHook = () => {

    const [loading, setLoading] = useState(false);

    return [
      loading ? <FullPageLoaderModal /> : null,
      () => setLoading(true),
      () => setLoading(false)
    ];
  };

export default UseFullPageLoaderHook